import axios from "axios";

export const baseClient = () => {
	return axios.create();
};

export const authClient = (token) => {
	return axios.create({
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Methods": "*",
			Authorization: `Bearer ${token}`,
		},
		"Access-Control-Allow-Credentials": true,
	});
};

const PRO =
	process.env.NODE_ENV === "production" || process.env.NODE_ENV === "pro";

export const API = PRO
	? "https://dalibith-api.azurewebsites.net/api"
	: "https://localhost:7298/api";

export const SERVER_URL = /*PRO
  ? ''
  : */ "http://localhost:4001";
